export class HoloLiveError extends Error {
    code;
    retryable;
    cause;
    constructor(message, code, retryable = false, cause) {
        super(message);
        this.code = code;
        this.retryable = retryable;
        this.cause = cause;
        this.name = "HoloLiveError";
    }
}
export class APIError extends HoloLiveError {
    status;
    trace_id;
    constructor(message, code, retryable, status, trace_id) {
        super(message, code, retryable);
        this.status = status;
        this.trace_id = trace_id;
        this.name = "APIError";
    }
}
export const stalePlanError = () => new HoloLiveError("stale media plan", "stale_plan");
